import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import { trans } from '../../../helpers/index';
import ApiManager from '../../../apiManager/index';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import Modal from '../../Fragments/Modal';
import SimpleCrypto from 'simple-crypto-js';
import config from '../../../baseConfig/index';
import ErrorModal from '../../Fragments/ErrorModal';

class FixinStep2 extends Component {

    constructor( props ){
        super( props );

        this.state = {
            buttonDisabled: false,
            password: '',
            rePassword: '',
            passwordMaxLength: 8,
            agreeWithTerms: 0,
            code: '',
            formResponse: '',
            successModal: false,
            showErrorModal: false
        };

        this.signIn = this.signIn.bind( this );

    }

    successModal(){

        if ( !this.state.successModal ) {
            return '';
        }

        return (
            <Modal
                title={trans(this.props.trans, 'auth.register.success.title')}
                description={trans(this.props.trans, 'auth.register.success.description')}
                agreeText={trans(this.props.trans, 'auth.register.success.agree')}
                agreeAction={this.signIn}
            />
        );

    }

    calcStepWidth(){

        return (100 / this.props.fixConfig.fixMaxStep) * this.props.fixConfig.fixStep

    }

    signIn(){

        ApiManager.postRequest({
            username: this.props.fixConfig.fixLogin,
            password: this.state.password,
            _token: this.props.csrf_token.data
        }, '/login').then(( resolve ) => {

            if ( resolve.data.status === 'OK' ) {
                let simpleCrypto = new SimpleCrypto( config.simpleCryptoSecretKey );
                this.props.cookies.set('loginToken', simpleCrypto.encrypt( resolve.data.jwt ), { path: config.urlPrefix });
                this.props.history.push(config.urlPrefix + 'profile');
            }

        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });

    }

    toggleCheckbox( event ){

        this.setState({
            agreeWithTerms: event.target.checked ? 1 : 0
        });

    }

    sendData( event ){

        this.setState({ buttonDisabled: true });

        ApiManager.postRequest({
            code: this.state.code,
            password: this.state.password,
            password_confirmation: this.state.rePassword,
            agree_with_terms: this.state.agreeWithTerms,
            token: this.props.fixConfig.fixToken,
            _token: this.props.csrf_token.data
        }, '/register/fixin/set-password').then(( resolve ) => {
            this.setState({
                buttonDisabled: false,
                formResponse: resolve.data
            });

            if ( resolve.data.status === 'OK' ) {
                this.setState({ successModal: true });
            }

        }, ( reject ) => {
            this.setState({ showErrorModal: true });
        });
        event.preventDefault();

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.trans, 'error.modal.title' )}
                description={trans( this.props.trans, 'error.modal.description' )}
                action_text={trans( this.props.trans, 'error.modal.action_text' )}
            />
        );

    }

    render () {

        let passwordsCountIsValid = this.state.password.length >= this.state.passwordMaxLength && this.state.rePassword.length >= this.state.passwordMaxLength,
            passwordStrongest = ['form__pass-type-box--weak', 'form__pass-type-box--average', 'form__pass-type-box--strong'],
            passwordStrongestClass = '',
            errorCodeClass = '',
            errorCodeBox = '',
            errorPasswordClass = '',
            errorPasswordBox = '',
            errorPasswordConfirmClass = '',
            errorPasswordConfirmBox = '',
            errorAgreeWithTermsClass = '',
            errorAgreeWithTermsBox = '',
            errorBox = '';

        if ( this.state.password.length >= this.state.passwordMaxLength ) {

            // Only numbers or letters
            if ( /^\d+$|^[A-Za-z]+$|^[^\s].[^\sa-z0-9]+$/i.test(this.state.password) ) {
                passwordStrongestClass = ' '+passwordStrongest[0];
            } else if ( /^[a-z0-9]+$/i.test(this.state.password) ) {
                passwordStrongestClass = ' '+passwordStrongest[1];
            } else if ( /[a-z0-9]+/i.test(this.state.password) && /^[^\s].[^\s]+$/i.test(this.state.password) ) {
                passwordStrongestClass = ' '+passwordStrongest[2];
            }

        }

        if ( this.state.formResponse !== '' ) {

            if ( this.state.formResponse.status === 'INVALID_DATA' ) {

                if ( this.state.formResponse.errors.hasOwnProperty('password') ) {
                    errorPasswordClass = ' form-error';
                    errorPasswordBox = <div className="form-error-text fs11">{this.state.formResponse.errors.password}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('password_confirmation') ) {
                    errorPasswordConfirmClass = ' form-error';
                    errorPasswordConfirmBox = <div className="form-error-text fs11">{this.state.formResponse.errors.password_confirmation}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('agree_with_terms') ) {
                    errorAgreeWithTermsClass = ' form-error';
                    errorAgreeWithTermsBox = <div className="form-error-text form-error-text--top-space fs11">{this.state.formResponse.errors.agree_with_terms}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('code') ) {
                    errorCodeClass = ' form-error';
                    errorCodeBox = <div className="form-error-text fs11">{this.state.formResponse.errors.code}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('token') ) {
                    errorBox = <FormMiddlewareError message={this.state.formResponse.errors.token} />;
                }

            }

            if ( this.state.formResponse.status === 'ERROR' ) {

                errorBox = <FormMiddlewareError message={this.state.formResponse.message} trans={this.props.trans} />;

            }

        }

        return (
            <div className="form">

                <form action="#" method="post" onSubmit={(event) => this.sendData( event )}>

                    <div className="form__form-box form__form-box--with-space form-box">
                        <div className="form__sub-title db fs11">{this.props.fixConfig.fixStep} {trans(this.props.trans, 'auth.register.step.title')} {this.props.fixConfig.fixMaxStep}{trans(this.props.trans, 'auth.register.step' + this.props.fixConfig.fixMaxStep)}</div>
                        <div className="form__step-out">
                            <div className="form__step" style={{width: this.calcStepWidth() + '%'}}></div>
                        </div>
                    </div>
                    <div className="form__form-box form-box">
                        <label className="form__label db fs11" htmlFor="number">{trans(this.props.trans, 'auth.register.fixin.label4')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13 disabled"
                                disabled="disabled"
                                id="number"
                                type="text"
                                name="number"
                                value={this.props.fixConfig.fixBanId}
                            />
                        </div>
                        <div className="form-error-text dn fs13">Error text</div>
                    </div>
                    <div className="form__form-box form__form-box--with-space form-box">
                        <label className="form__label db fs11" htmlFor="email">{trans(this.props.trans, 'auth.register.fixin.label5')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13 disabled"
                                disabled="disabled"
                                id="email"
                                type="text"
                                name="email"
                                value={this.props.fixConfig.fixEmail}
                            />
                        </div>
                        <div className="form-error-text dn fs13">Error text</div>
                    </div>

                    <div className={`form__form-box${errorCodeClass}`}>
                        <label className="form__label db fs11" htmlFor="code">{trans(this.props.trans, 'auth.register.fixin.label6')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="code"
                                type="text"
                                name="code"
                                value={this.state.code}
                                onChange={( event ) => {
                                    this.setState({
                                        code: event.target.value.trim().replace(/[^\d]/g, '')
                                    });
                                }}
                            />
                        </div>
                        {errorCodeBox}
                    </div>

                    <div className={`form__form-box${errorPasswordClass}`}>
                        <label className="form__label  db fs11" htmlFor="password">{trans(this.props.trans, 'auth.register.fixin.label7')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field form__field--right-space fs13"
                                id="password"
                                type="password"
                                name="password"
                                placeholder={trans(this.props.trans, 'auth.register.fixin.password.placeholder1')}
                                value={this.state.password}
                                onChange={( event ) => {
                                    this.setState({ password: event.target.value.trim() });
                                }}
                            />
                            <div className={`form__pass-type-box${passwordStrongestClass} pa`}>
                                <div className="form__pass-point ver-top-box"></div>
                                <div className="form__pass-point ver-top-box"></div>
                                <div className="form__pass-point ver-top-box"></div>
                            </div>
                        </div>
                        {errorPasswordBox}
                        <div className="form__details-txt fs11">{trans(this.props.trans, 'auth.register.fixin.password.note')}</div>
                    </div>

                    <div className={`form__form-box form__form-box--with-space${errorPasswordConfirmClass}`}>
                        <label className="form__label  db fs11" htmlFor="password-again">{trans(this.props.trans, 'auth.register.fixin.label8')}</label>
                        <div className="form__field-out pr">
                            <input
                                className="form__field fs13"
                                id="password-again"
                                type="password"
                                name="password-again"
                                placeholder={trans(this.props.trans, 'auth.register.fixin.password.repeat.placeholder1')}
                                value={this.state.rePassword}
                                onChange={( event ) => {
                                    this.setState({ rePassword: event.target.value.trim() });
                                }}
                            />
                        </div>
                        {errorPasswordConfirmBox}
                    </div>

                    <div className={`form__form-box form__form-box--with-space${errorAgreeWithTermsClass}`}>
                        <div className="form__checkbox-out ver-top-box">
                            <input
                                className="form__checkbox dn"
                                id="check-conditions"
                                name="check-conditions"
                                type="checkbox"
                                value={this.props.agreeWithTerms}
                                onChange={( event ) => this.toggleCheckbox( event )}
                            />
                            <label className="form__check-label pr db" htmlFor="check-conditions"></label>
                        </div><div className="form__link-conditions-out ver-top-box">
                            <a className="form__link-conditions fs15" href="https://google.com">{trans(this.props.trans, 'auth.register.fixin.terms')}</a>
                        </div>
                        {errorAgreeWithTermsBox}
                    </div>

                    {errorBox}

                    <button
                        className={`form__submit-btn btn btn--yellow fs17${this.state.buttonDisabled ? ' btn--loading' : ''}`}
                        type="submit"
                        disabled={!passwordsCountIsValid || this.state.buttonDisabled}
                    >{trans(this.props.trans, 'auth.register.fixin.button.title2')}</button>

                </form>

                {this.successModal()}
                {this.errorModal()}

            </div>
        );

    }

}

export default withRouter( withCookies( FixinStep2 ) );